/* eslint-disable react-hooks/exhaustive-deps */
import "suneditor/dist/css/suneditor.min.css";
import React, { useEffect, useRef, useState } from "react";
import SunEditor from "suneditor-react";
import { fileUpload } from "../../utils/file";
import { viewLoading } from "../../utils/loading";
import { classnames } from "../../utils/text";
import { isFunction } from "lodash";
import Button from "../Button";

const Editor = ({
  value,
  onChange: _onChange,
  name,
  readOnly = false,
  className,
  height = "500"
}) => {

  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleImageUpload = (files, info, uploadHandler) => {
    viewLoading(true);
    const file = files[0];

    fileUpload(file, true, true).then((res) => {
      let imgUrl = res.fileUrl;
      const startSignTextIdx = imgUrl.indexOf("?X-Amz-Algorithm");
      if (startSignTextIdx > -1) {
        imgUrl = imgUrl.slice(0, startSignTextIdx);
      }

      uploadHandler({
        result: [
          {
            url: imgUrl,
            name: res.name,
            size: res.size,
          },
        ],
      });
    }).finally(() => {
      viewLoading(false);
    });
    return false;
  };
  const [val, setVal] = useState(value);

  const onChange = (e) => {
    setVal(e);
  };

  useEffect(() => {
    if (isFunction(_onChange)) {
      _onChange({
        target: {
          name,
          value: val,
        },
      });
    }
  }, [val]);

  const editor = useRef();
  const getSunEditorInstance = (sunEditor) => {
    editor.current = sunEditor;
  };

  let additionalProps = {};
  if (readOnly) {
    additionalProps = {
      disable: true,
      enableToolbar: false,
      showToolbar: false,
      hideToolbar: true,
      setContents: value,
      width: '100%',
      height: '100%',
      setOptions: { resizingBar: false, showPathLabel: false },
    };
  }
  const toggleFullScreen = (isFull) => {
    setIsFullScreen(isFull);
  };

  const closeEditorMode = () => {
    const fullScreenBtn = document.querySelectorAll('[aria-label="Full screen"]')[0];
    if (fullScreenBtn) {
      fullScreenBtn.click();
    }
  };

  return (
    <>
      <div className={classnames('editor', className, {
        'read-only': readOnly,
        'full-screen': isFullScreen,

      })}>
        <div className="editor-wrap">
          {isFullScreen &&
            <>
              <Button
                action={closeEditorMode}
                color="text"
                className={'editor-full-screen-button'}
              >
                에디터모드 닫기
              </Button>
            </>
          }
          <div className="editor-box">
            <SunEditor
              setDefaultStyle="font-family: 'Noto Sans KR';line-height: 1.66;color: 'rgba(31, 31, 31, 1)';"
              height={height}
              onImageUploadBefore={handleImageUpload}
              defaultValue={value}
              setContents={value}
              onChange={onChange}
              getSunEditorInstance={getSunEditorInstance}
              toggleFullScreen={toggleFullScreen}
              setOptions={{
                font: [
                  'SUIT',
                  'Arial',
                  'Comic Sans MS',
                  'Courier New',
                  'Impact',
                  'Georgia',
                  'tahoma',
                  'Trebuchet MS',
                  'Verdana',
                ],
                fontSize: [8, 10, 14, 18, 24, 36],
                buttonList: [
                  ['undo', 'redo'],
                  ['font', 'fontSize', 'formatBlock'],
                  [
                    'bold',
                    'underline',
                    'italic',
                    'strike',
                    'subscript',
                    'superscript',
                  ],
                  ['removeFormat'],
                  '/',
                  ['fontColor', 'hiliteColor'],
                  ['lineHeight', 'outdent', 'indent'],
                  ['align', 'horizontalRule', 'list', 'table'],
                  ['link', 'image', 'video'],
                  ['fullScreen', 'showBlocks', 'codeView'],
                  ['preview', 'print'],
                  // ['save', 'template'],
                ],
                charCounterType: 'byte-html',
              }}
              {...additionalProps}
            />
          </div>
        </div>
      </div >
    </>
  );
};

export default Editor;
